import { createElementBlock as o, openBlock as l, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return l(), o("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.884 4.986v5.029a1.986 1.986 0 0 1-3.971 0v-5.03a1.986 1.986 0 1 1 3.97 0m-5.971 0a3.986 3.986 0 1 1 7.97 0v5.029a3.986 3.986 0 0 1-7.97 0zM19 10a1 1 0 0 1 1 1c0 1.407-.695 3.144-1.989 4.52C16.69 16.929 14.704 18 12.093 18c-2.607 0-4.632-1.069-5.997-2.465C4.76 14.169 4 12.43 4 11a1 1 0 1 1 2 0c0 .799.472 2.06 1.526 3.137C8.549 15.183 10.07 16 12.093 16c2.019 0 3.488-.814 4.461-1.85C17.556 13.086 18 11.823 18 11a1 1 0 0 1 1-1m-6.942 9a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const v = { render: t };
export {
  v as default,
  t as render
};
//# sourceMappingURL=ic_voice-Bsywo5o6.js.map
